import React, { useRef } from "react";
import { Button } from "primereact/button";
import DealerWarehouseTable from "./components/DealerWarehouseTable";
import DealerWarehouseForm from "./components/DealerWarehouseForm";
import DealerWarehouseFilters from "./components/DealerWarehouseFilters";
import useDealerWarehouseData from "./hooks/useDealerWarehouseData";
import useDealerWarehouseForm from "./hooks/useDealerWarehouseForm";
import { useLanguage } from "../../contexts/LanguageContext";

const DealerWarehousePage = () => {
  const { th } = useLanguage();

  const {
    // liste & durumlar
    rows,
    loading,
    totalCount,
    pagination,
    filters,
    // mutation durumları
    isCreating,
    isUpdating,
    isDeleting,
    // filtre meta / işlemler
    filterFields,
    customFilterTypes,
    customFilterOptions,
    handleDelete,
    saveWarehouse,
    handleSearch,
    handleFilterChange,
    handleResetFilters,
    handleApplyFilters,
    onPageChange
  } = useDealerWarehouseData();

  // form hook
  const formProps = useDealerWarehouseForm(saveWarehouse);

  const columnsRef = useRef(null);

  return (
    <div className="card">
      {(isCreating || isUpdating || isDeleting) && (
        <div className="card-overlay">
          <div className="loading-indicator">
            <i className="pi pi-spin pi-spinner" style={{ fontSize: "2rem" }} />
          </div>
        </div>
      )}

      <div className="flex justify-content-between align-items-center mb-4">
        <h1 className="m-0">{th("dealerWarehouse.title") || "Ambar Tanımlamaları"}</h1>
        {/* <Button
          label={th("dealerWarehouse.new") || "Yeni Ambar"}
          icon="pi pi-plus"
          onClick={formProps.handleAddNew}
        /> */}
      </div>

      <DealerWarehouseForm {...formProps} />

      <div className="mb-2">
        <DealerWarehouseFilters
          filterFields={filterFields}
          columns={columnsRef.current}
          customFilterTypes={customFilterTypes}
          customFilterOptions={customFilterOptions}
          handleSearch={handleSearch}
          handleApplyFilters={handleApplyFilters}
          handleResetFilters={handleResetFilters}
          handleFilterChange={handleFilterChange}
        />
      </div>

      <DealerWarehouseTable
        rows={rows}
        loading={loading}
        totalCount={totalCount}
        pagination={pagination}
        onPageChange={onPageChange}
        filters={filters}
        handleEdit={formProps.handleEdit}
        handleDelete={handleDelete}
      />
    </div>
  );
};

export default DealerWarehousePage;
